export default "__VITE_ASSET__DmDBTvAR__"